import React from 'react';
import moment from 'moment/moment';
import { formatCurrency, formatDate } from './utils';

export default function DashboardStats({ totalEarned, totalRecs, completedPaymentsCount, nextPayment, res }) {
    const contractTermYears = res.contract_start_date && res.contract_end_date
        ? moment(res.contract_end_date).diff(moment(res.contract_start_date), 'years')
        : null;

    return (
        <div className="db-stats">
            <div className="db-stat-card db-stat-card--green">
                <div className="db-stat-label">Total Earned</div>
                <div className="db-stat-value">{formatCurrency(totalEarned)}</div>
                <div className="db-stat-sub">{completedPaymentsCount} payments received</div>
            </div>
            <div className="db-stat-card db-stat-card--blue">
                <div className="db-stat-label">Next Est. Payment</div>
                <div className="db-stat-value db-stat-value--sm">{nextPayment}</div>
                <div className="db-stat-sub">Based on generation cycle</div>
            </div>
            <div className="db-stat-card db-stat-card--amber">
                <div className="db-stat-label">RECs Delivered</div>
                <div className="db-stat-value">{totalRecs.toFixed(1)}</div>
                <div className="db-stat-sub">@ {res.rec_price != null ? formatCurrency(res.rec_price) : '—'} per REC</div>
            </div>
            <div className="db-stat-card db-stat-card--navy">
                <div className="db-stat-label">Contract Term</div>
                <div className="db-stat-value db-stat-value--sm">
                    {contractTermYears != null ? `${contractTermYears} years` : '—'}
                </div>
                <div className="db-stat-sub">
                    {res.contract_start_date && res.contract_end_date
                        ? `${formatDate(res.contract_start_date)} – ${formatDate(res.contract_end_date)}`
                        : '—'}
                </div>
            </div>
        </div>
    );
}
